export enum DataType
{
  New = 1,
  Deleted = 2,
  NoChange = 3,
  Updated=4,
}
